/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResourceLogsDto } from './ResourceLogsDto';
import {
    ResourceLogsDtoFromJSON,
    ResourceLogsDtoFromJSONTyped,
    ResourceLogsDtoToJSON,
} from './ResourceLogsDto';

/**
 * 
 * @export
 * @interface DeploymentLogsDto
 */
export interface DeploymentLogsDto {
    /**
     * The resource.
     * @type {Array<ResourceLogsDto>}
     * @memberof DeploymentLogsDto
     */
    resources: Array<ResourceLogsDto>;
}

/**
 * Check if a given object implements the DeploymentLogsDto interface.
 */
export function instanceOfDeploymentLogsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resources" in value;

    return isInstance;
}

export function DeploymentLogsDtoFromJSON(json: any): DeploymentLogsDto {
    return DeploymentLogsDtoFromJSONTyped(json, false);
}

export function DeploymentLogsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentLogsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resources': ((json['resources'] as Array<any>).map(ResourceLogsDtoFromJSON)),
    };
}

export function DeploymentLogsDtoToJSON(value?: DeploymentLogsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resources': ((value.resources as Array<any>).map(ResourceLogsDtoToJSON)),
    };
}

